<template>
  <v-container align-center>
    <v-layout col wrap justify-center>
      <v-flex xs12 md10 pa-0>
        <v-card>
          <div class="hide-overflow" style="position: relative;">
            <v-toolbar color="lime" absolute>
              <v-toolbar-title style="color:#0b2b49">Hotel List</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-flex xs4 sm4 md4>
                <v-text-field label="search" v-model="search"></v-text-field>
              </v-flex>
            </v-toolbar>
            <div id="scrolling-techniques" class="scroll-y" style="height:80%; margin-top: 50px;">
              <v-container>
                <v-list two-line>
                  <template v-for="(hotel, index) in filterHotels">
                    <v-list-tile :key="hotel.id" avatar ripple @click="onLoadHotel(hotel.id)">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ hotel.name }}</v-list-tile-title>
                        <v-list-tile-action-text>{{ hotel.sector }}</v-list-tile-action-text>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="index + 1 < filterHotels.length" :key="index"></v-divider>
                  </template>
                </v-list>
              </v-container>
            </div>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
    <v-btn
      v-if="isAdmin"
      bottom
      right
      fixed
      dark
      fab
      color="green"
      router
      to="/HotelList/new"
      style="margin-bottom:50px;"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-btn
      bottom
      right
      fixed
      fab
      color="lime"
      style="margin-right:70px; margin-bottom:50px;"
      @click="scrollToTop"
    >
      <v-icon>arrow_upward</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      search: ""
    };
  },
  computed: {
    filterHotels: function() {
      // console.log(this.$store.getters.loadedHotels);

      return this.$store.getters.loadedHotels.filter(hotel => {
        // If i return True then the contact Stays in the array, if i return False then this contact is Removed from the array
        const filtered =
          hotel.name.toLowerCase().match(this.search.toLowerCase()) ||
          hotel.area.toLowerCase().match(this.search.toLowerCase()) ||
          hotel.sector.toLowerCase().match(this.search.toLowerCase()) ||
          hotel.mobile.toLowerCase().match(this.search.toLowerCase()) ||
          hotel.mobile_short.toLowerCase().match(this.search.toLowerCase());

        return filtered;
      });
    },
    loading() {
      return this.$store.getters.loading;
    },
    isAdmin() {
      if (this.$store.getters.user.id === "l0GxQQzn9iTs5phuG7FvifWvorR2") {
        return true;
      } else {
        return false;
      }
    }
  },
created() {
    var hotels = this.$store.dispatch("loadHotels");
  },
  methods: {
    onLoadHotel(id) {
      this.$router.push("/Hotel/" + id);
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
};
</script>